import { useCallback, memo } from 'react'
import Point3DNode from '../../../Common/Nodes/Point3DNode'

import useStore from '../../../../modules/store'
import { selectedSelector } from '../../../../modules/sceneCubeListStore'
import { getFirstSelected } from '../../../../modules/cubeEditorStore'
import { setPointAction } from '../../../../modules/sceneCubeStore'

const CEPositionNode = () => {
  const point = useStore(
    useCallback((state) => {
      const { cube } = getFirstSelected(state)
      return cube ? cube.point : null
    }, [])
  )
  const selected = useStore(selectedSelector)
  const setPoint = useStore(setPointAction)

  const handleChange = useCallback(
    (id, newValue) => {
      setPoint(selected[0], newValue)
    },
    [selected, setPoint]
  )

  return selected.length === 1 ? (
    <Point3DNode
      id={'point'}
      label="Posicion"
      value={point}
      onChange={handleChange}
    />
  ) : null
}
export default memo(CEPositionNode)
